<template>
  <div class="emp-report">
    <div class="header d-flex space-between">
      <div class="header-title flex flex-column">
        <h1 class="upper-case">Nomi.NA, Sociedad Anonima</h1>
        <p class="upper-case">Rio Hondo, Zacapa</p>
        <p class="bold">Telefono: 59926793</p>
      </div>
      <div class="d-flex flex-column flex-grow-1">
        <p class="d-flex">
          <span>Comprobante No:</span>
          <span class="flex-grow-1 text-center">{{ receiptNum }}</span>
        </p>
        <p class="d-flex">
          <span>Codigo:</span>
          <span class="flex-grow-1 text-center">{{ emp.cId }}</span>
        </p>
      </div>
    </div>
    <div class="summary d-flex flex-column">
      <div>
        <p class="group">
          <span>Recibi de:</span>
          <span class="bold">Nomi.na, Sociedad Anonima</span>
        </p>
        <div class="d-flex justify-space-between align-center">
          <div class="group">
            <span>La Cantidad de:</span>
            <span class="bold">{{ totalStr }}</span>
          </div>
          <div class="total">
            {{
              emp.total.toLocaleString('en-US', { minimumFractionDigits: 2 })
            }}
          </div>
        </div>
        <p class="group">
          <span>Por Concepto de:</span>
          <span class="bold"
            >Anticipo de Honorarios por Servicios Técnicos
            {{ dateRange }}.</span
          >
        </p>
      </div>
    </div>
    <div class="details d-flex">
      <div class="d-flex flex-column">
        <p>
          <span>Extras:</span><span class="ml-2">{{ emp.extraHours }}</span>
        </p>
        <table class="flex-grow-1">
          <thead>
            <tr>
              <th colspan="2">Ingresos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Honorarios</td>
              <td>{{ emp.monthSalaryNomina }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Extra Honorarios</td>
              <td>{{ emp.extraValueNomina }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <p class="sum">
          <span>Total Ingresos:</span
          ><span>{{
            emp.monthSalaryNomina.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })
          }}</span>
        </p>
      </div>
      <div class="d-flex ml-3 flex-column">
        <p>
          <span>Servicios Prestados:</span
          ><span class="ml-2">{{ emp.totalDays }}</span>
        </p>
        <table>
          <thead>
            <tr>
              <th colspan="2">Descuentos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Cafeteria San Jorge</td>
              <td>{{ emp.shop.sanJorge && emp.shop.sanJorge.amount }}</td>
            </tr>
            <tr>
              <td>Cafeteria San Jose</td>
              <td>{{ emp.shop.sanJose && emp.shop.sanJose.amount }}</td>
            </tr>
            <tr>
              <td>Cafeteria El Paso</td>
              <td>{{ emp.shop.elPaso && emp.shop.elPaso.amount }}</td>
            </tr>
            <tr>
              <td>Des. Tarjeta Monedero</td>
              <td>{{ emp.disc.wallet && emp.disc.wallet.amount }}</td>
            </tr>
            <tr>
              <td>Anticipo de Honorarios</td>
              <td>{{ emp.disc.loan && emp.disc.loan.amount }}</td>
            </tr>
            <tr>
              <td>Des. Tarjeta de Salud y Pulmones</td>
              <td>{{ emp.disc.health && emp.disc.health.amount }}</td>
            </tr>
            <tr>
              <td>Antecedentes Penales</td>
              <td>{{ emp.disc.record && emp.disc.record.amount }}</td>
            </tr>
          </tbody>
        </table>
        <p class="sum">
          <span>Total Descuentos:</span
          ><span>{{
            emp.totalDisc.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })
          }}</span>
        </p>
      </div>
    </div>
    <div class="d-flex">
      <div class="flex-grow-1 small-details">
        <p class="group">
          <span>Fecha:</span>
          <span>{{ currDateStr }}</span>
        </p>
        <p class="bold">Forma Pago:</p>
        <p>{{ emp.bankAcc }}</p>
        <p>Original: Archivo personal</p>
        <p>Copia: Pres. Servicios</p>
      </div>
      <div class="total-container flex-grow-1 d-flex justify-space-between">
        <p class="upper-case">Liquido a Recibir:</p>
        <div class="total">
          {{ emp.total.toLocaleString('en-US', { minimumFractionDigits: 2 }) }}
        </div>
      </div>
    </div>
    <div class="signature d-flex justify-space-between">
      <div class="copy">{{ isCopy ? 'Copia' : 'Original' }}</div>
      <div>
        <div class="d-flex">
          <span>F.</span>
          <span class="signature-line flex-grow-1"></span>
        </div>
        <div class="text-center">
          <span class="">{{ emp.name }}</span>
        </div>
        <div class="d-flex">
          <span class="bold">DPI</span>
          <span class="bold text-center flex-grow-1">{{ emp.dpi }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import writtenNumber from 'written-number';
import { formatDate, getEraDate } from '../services/timeUtils';
import { capitalize } from '../services/utils';
export default {
  props: ['emp', 'filterBy', 'isCopy'],
  computed: {
    totalStr() {
      // TODO: THIS EMP TOTAL IS NUMBER OR STRING??? TOFIXED
      return writtenNumber(this.emp.total, { lang: 'es' }).toUpperCase();
    },
    currDateStr() {
      const dateArr = new Date()
        .toLocaleDateString('es-GU', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
        .split(' ');
      dateArr[2] = capitalize(dateArr[2]);
      return dateArr.join(' ');
    },
    dateRange() {
      const { fromDate, toDate } = getEraDate(
        this.filterBy.date,
        this.filterBy.era,
      );
      return (
        formatDate(fromDate, true, '/') + ' al ' + formatDate(toDate, true, '/')
      );
    },
    receiptNum() {
      const date = new Date(this.filterBy.date);
      const year = (date.getFullYear() + '').substring(2);
      return (
        '' + this.emp.cId + year + (date.getMonth() + 1) + this.filterBy.era
      );
    },
  },
};
</script>

<style lang="scss">
.emp-report {
  p {
    margin-bottom: -4px !important;
  }

  font-family: 'Times New Roman', Times, serif;
  background-color: white;
  padding: 8px;
  border: 4px solid black;

  &.dense {
    padding: 0 4px;
    font-size: 13px;

    .details {
      margin-bottom: 8px;
    }

    table {
      td {
        padding: 0 5px;
        // height: 25px;
      }
    }
  }

  .bold {
    font-weight: 700;
  }

  .upper-case {
    text-transform: uppercase;
  }

  .summary,
  .header {
    h1 {
      font-weight: 700;
      font-size: 27px;
      margin-bottom: -8px;
    }

    margin-bottom: 7px;

    &-title p {
      margin-bottom: -6px !important;
    }
  }

  .details {
    & > div {
      flex-grow: 1;
    }

    margin-bottom: 7px;

    p {
      display: flex;
      margin-inline-start: 5px;
      // justify-content: space-around;
      margin-bottom: 0;
    }

    .sum {
      display: flex;
      align-items: center;

      span:last-of-type {
        text-align: center;
        border-bottom: 2px solid black;
      }

      & > * {
        flex-grow: 1;
      }
    }
  }

  .small-details {
    p {
      margin-bottom: 0;
    }
  }

  .total {
    border: 2px solid black;
    min-width: 170px;
    text-align: center;
  }

  .total-container {
    align-items: center;
    font-size: 25px;

    & > .total {
      padding: 8px;
    }

    p {
      margin-bottom: 0;
    }
  }

  .signature {
    & > * {
      flex-grow: 1;
    }

    &-line {
      border-bottom: 2px solid black;
    }

    .copy {
      display: flex;
      align-items: center;
      text-transform: uppercase;
      font-size: 30px;
      font-weight: 800;
    }
  }

  table {
    border: 1px solid black;
    border-collapse: collapse;

    th {
      border: 2px solid black;
    }

    td {
      padding: 3px 5px;
      // height: 30px;
    }
  }

  .group {
    span:last-of-type {
      margin-left: 7px;
    }
  }

  p {
    margin-bottom: 5px;
  }
}
</style>
